import styled from '@emotion/styled'

export const KP11LayoutContainerStyle = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 3fr) minmax(0, 2fr);
  height: 100%;
  background: #f4f6fb;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const KP11LayoutCatalogWrapStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 40px 60px;
  height: 100%;
  position: relative;
  overflow-x: auto;
  overflow-y: auto;
  flex-wrap: nowrap;
  width: 100%;

  > * {
    min-width: 300px;
    flex-shrink: 0;
  }

  /* thin scrollbar */
  &::-webkit-scrollbar {
    height: 6px;
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 3px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.3) transparent;
`
export const KP11LayoutOrderSummaryWrapStyle = styled(
  KP11LayoutCatalogWrapStyle,
)`
  background: #ffffff;
`
